/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const file_zip = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="m5.418 15.214 1.916-3.11v-.687H4.306v.786h1.843l-1.916 3.11V16h3.14v-.786H5.419Zm5.712-3.011v-.786H8.365v.786h.89v3.011h-.89V16h2.765v-.786h-.888v-3.011h.888Zm2.638-.786h-1.652V16h.987v-1.768h.665c.994 0 1.574-.517 1.574-1.407s-.58-1.408-1.574-1.408Zm-.158 2.03h-.507v-1.244h.507c.5 0 .73.196.73.622 0 .425-.23.622-.73.622Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.792 10V5.446a.92.92 0 0 0-.267-.648L8.957 1.21a.91.91 0 0 0-.645-.27h-6.46a.914.914 0 0 0-.91.917v11.916c0 .506.407.917.91.917H3m9.792-9.166H9.146a.914.914 0 0 1-.912-.917V.94"
    />
  </svg>
)
export default file_zip
